import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() { 
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
  <Row>
  <Col md={8} className="home-about-description">
    <h1 style={{ fontSize: "2.6em" }}>
      LET ME <span className="purple"> INTRODUCE </span> MYSELF
    </h1>
    <p className="home-about-body">
      I'm fluent in
      <i>
        <b className="purple"> Python, C, C++, and JavaScript</b>
      </i>, and skilled in building responsive user interfaces and full-stack applications.
      <br />
      <br />
      I enjoy working with the
      <i>
        
      </i>modern frontend frameworks like
      <i>
        <b className="purple"> React.js and Next.js</b>
      </i>.
      <br />
      <br />
      I'm passionate about
      <b className="purple"> web scraping,selenium </b>, and exploring machine learning by
      <i>
        <b className="purple"> fine-tuning open-source models on Hugging Face using Colab</b>
      </i>.
      <br />
      <br />
      I actively participate in
      <b className="purple"> open source projects</b> and enjoy solving algorithmic challenges through
      <b className="purple"> competitive programming</b>.
    </p>
  </Col>
  <Col md={4} className="myAvtar">
    <Tilt>
      <img src={myImg} className="img-fluid" alt="avatar" />
    </Tilt>
  </Col>
</Row>


        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/prabhatyadav60"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://x.com/yadavpiy02"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/prabhat-yadav-404b7727a/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
